import { SubMenuList } from '../sub-menu-list';

export class GeneralSetupButton extends SubMenuList {
  name = 'general-setup-button';
}
